const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const moment = require('moment');
const classnames = require('classnames');
const { Link } = require('react-router-dom');
const { contains } = require('lodash');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

//@ contants
const mortgageRequestStates = require('constants/mortgageRequestStates');
const statesAfterAprobadoRiesgos = [
    mortgageRequestStates.APROBADO_RIESGOS,
    mortgageRequestStates.APERTURA_CUENTA,
    mortgageRequestStates.ESPERA_AUTORIZACION_SEGURO_HOGAR,
    mortgageRequestStates.GENERANDO_OV,
    mortgageRequestStates.ESPERA_DOC_FIRMA,
    mortgageRequestStates.PROV_FONDOS,
    mortgageRequestStates.GESTION_FECHA_FIRMA,
    mortgageRequestStates.ESPERA_ACTA_NOTARIO,
    mortgageRequestStates.PEND_MMPP,
    mortgageRequestStates.PEND_SALDO,
    mortgageRequestStates.PEND_FIRMA
];

// @ utils
const UrlHelper = require('utilities/urlHelper');


class MortgageRequestManagerPanelSignature extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
            id: 'stepSignature'
        };

        this.currentState = '';
        this.handleOnClickAccordion = this.handleOnClickAccordion.bind(this);
        this.buildStatusStep = this.buildStatusStep.bind(this);
        this.buildTargetDate = this.buildTargetDate.bind(this);
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        const { isExpandedSignature } = this.props;
        this.setState({ isExpanded: isExpandedSignature });
    }

    componentDidMount() {
        const { isExpandedSignature } = this.props;
        if (isExpandedSignature) {
            UrlHelper.scrollTo(this);
        }
    }

    getLinkFinanceMovingExpenses() {
        const { currentState, mortgageRequestMortgageData } = this.props;

        let linkFinanceMovingExpenses = '';
        const isAfterAprobadoRiesgos = contains(statesAfterAprobadoRiesgos, currentState);

        if (currentState === mortgageRequestStates.OFRECER_FINANCIACION_GASTOS &&
            (mortgageRequestMortgageData.getIn(['data', 'maximoImporteFinanciarGastos']) > 0)) {
                linkFinanceMovingExpenses = '/myprofile/mortgage/moving-expenses';
            } else if (isAfterAprobadoRiesgos && mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']) > 0) {
                linkFinanceMovingExpenses = '/myprofile/mortgage/moving-expenses-summary';
            } else if (isAfterAprobadoRiesgos && mortgageRequestMortgageData.getIn(['data', 'importeFinanciarGastos']) === 0) {
            linkFinanceMovingExpenses = '/myprofile/mortgage/moving-expenses-rejected';
        }

        return linkFinanceMovingExpenses;
    }

    buildFinanceExpensesContent() {
        let financeExpensesContent;
        const linkFinanceMovingExpenses = this.getLinkFinanceMovingExpenses();

        if (!!linkFinanceMovingExpenses) {

            financeExpensesContent = (
                <li>
                    <div className="row">
                        <Link
                            to={linkFinanceMovingExpenses}
                        >
                            <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente"></i>
                        </Link>
                        <div className="col-xs-7">
                            <FormattedText value="mortgageRequestPanel-accordionSignatureItemFinanceMovingExpenses" />
                        </div>
                    </div>
                </li>
            );
        }

        return financeExpensesContent;
    }

    buildStatusStep(classNameValue) {
        const { isApprovedSignature, stepNum } = this.props;
        let elementStatus = <span className="mortgage-request-manager-panel-steps__ico--step-approved"></span>;

        if (isApprovedSignature) {
            elementStatus = <h2 className={classNameValue}>{stepNum}</h2>;
        }
        return elementStatus;
    }

    buildTargetDate(date) {
        const dateFormatted = moment(date).format('DD/MM/YY');
        return (
            <div className="mortgage-request-manager-panel-steps__date-target">
                <p>
                    <strong>{formatText('mortgageRequestPanel-dataProprietorDataTarget')}: {dateFormatted}</strong>
                </p>
            </div>
        );
    }

    handleOnClickAccordion() {
        if (this.state.isExpanded) {
            this.setState({ isExpanded: false });
        } else {
            this.setState({ isExpanded: true });
        }
    }



    render() {
        const { mortgageRequestState, isExpandedSignature } = this.props;
        const linkExpensesProvision = '/myprofile/mortgage/expenses-provision';
        const linkSignatureDocuments = '/myprofile/mortgage/signature-documents';
        const financeMovingExpensesContent = this.buildFinanceExpensesContent();
        const itemActive = classnames(
            'step-item-num',
            {
                'step-item-num--active': this.state.isExpanded
            }
        );

        const getStatusStep = this.buildStatusStep(itemActive);
        let elementTargetDate;

        if (mortgageRequestState.get('fechaObjetivo')) {
            elementTargetDate = this.buildTargetDate(mortgageRequestState.get('fechaObjetivo'));
        }

        return (
            <div className="row step-item">
                <div className="col-xs-1">
                    {getStatusStep}
                </div>
                <div className="col-xs-11">

                    <Accordion
                        customClassName="mortgage-request-manager-panel-steps__collapsable"
                        isExpanded={isExpandedSignature}
                        id={this.state.id}
                        onClick={this.handleOnClickAccordion}
                    >
                        <AccordionHeader
                            name="AccordionHeader"
                            isRightArrowPosition={true}
                        >
                            <h3>{formatText('mortgageRequestPanel-accordionSignatureTitle')}</h3>
                            <p>{formatText('mortgageRequestPanel-accordionSignatureIntro')}</p>
                        </AccordionHeader>

                        <AccordionBody name="AccordionBody">
                            <div>
                                <ul className="list-unstyled mortgage-request-manager-panel-steps__list">
                                    {financeMovingExpensesContent}
                                    <li>
                                        <div className="row">
                                            <Link
                                                to={"/myprofile/mortgage/conditions"}
                                            >
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente"></i>
                                            </Link>
                                            <div className="col-xs-7">
                                                <p>{formatText('mortgageRequestPanel-accordionSignatureItemMortgageConditions')}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <Link
                                                to={linkExpensesProvision}
                                            >
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente"></i>
                                            </Link>
                                            <div className="col-xs-7">
                                                <p>{formatText('mortgageRequestPanel-accordionSignatureItemProvisionExpenses')}</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="row">
                                            <Link
                                                to={linkSignatureDocuments}
                                            >
                                                <i className="icon-breadcrumb mortgage-request-manager-panel-steps__ico--siguiente"></i>
                                            </Link>
                                            <div className="col-xs-7">
                                                <p>{formatText('mortgageRequestPanel-accordionSignatureItemPreparationSignature')}</p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </AccordionBody>
                    </Accordion>
                    {elementTargetDate}
                </div>
            </div>
        );
    }
}

MortgageRequestManagerPanelSignature.propTypes = {
    isExpandedSignature: PropTypes.bool,
    isApprovedSignature: PropTypes.bool,
    mortgageRequestState: PropTypes.object,
    currentState: PropTypes.string,
    mortgageRequestMortgageData: PropTypes.object,
    stepNum: PropTypes.number.isRequired

};

module.exports.constructor = MortgageRequestManagerPanelSignature;
module.exports.MortgageRequestManagerPanelSignature = connect(
    state => ({
        mortgageRequestState: state.mortgageRequestState,
    }), null)(MortgageRequestManagerPanelSignature);
